import { PrimaryLoadingIndicator, LoaderSize } from "@normasteaching/norma-ui";

export function FullPageLoading() {
  return (
    <div
      className={
        "min-h-screen min-w-screen flex flex-col items-center justify-center"
      }
    >
      <PrimaryLoadingIndicator size={LoaderSize.Large} />
    </div>
  );
}
